var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quickes group",attrs:{"width":"100%","tabindex":"0"},on:{"keydown":_vm.keydown}},[_c('button-row',{attrs:{"items":_vm.phrases,"focus":false},on:{"buttonclick":_vm.say}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }